import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { RMSvgIconProps } from 'components/customComponents/CommonComponents/RMSvgIcon';
import React, { useState, useCallback, useRef } from 'react';
import { IStyle } from 'Styles';
import { headerButtonsColor } from 'utils/Global';
import './styles.scss';
interface HeaderTitleProps {
  title: string;
  setTitle?: (title: string) => void;
  isNewTheme?: boolean;
}
const renameIconProps: RMSvgIconProps = {
  name: 'Edit',
  fill: headerButtonsColor,
  style: { marginLeft: '2%' },
};
let textAreaWidth = 250;
let textAreaHeight = 10;
function HeaderTitle(props: HeaderTitleProps) {
  const { title, setTitle, isNewTheme } = props;
  const [renameTitle, setRenameTitle] = useState<boolean>(false);
  const textAreaRef = useRef(null);
  const divRef = useRef(null);
  const renameHandler = useCallback(() => {
    setRenameTitle((prevState) => !prevState);
    const width = divRef.current.offsetWidth;
    const height = divRef.current.offsetHeight;
    textAreaRef.current.focus();
    if (width != 0) {
      textAreaWidth = width;
    }
    if (height != 0) {
      textAreaHeight = height;
    }
  }, [divRef]);
  const handleOnBlur = useCallback(() => {
    setRenameTitle(false);
  }, []);
  const handleOnChange = useCallback((e) => {
    setTitle(e.target.value);
  }, []);
  return (
    <div id="headertitle-main-container" style={styles.mainContainer}>
      <div id="headertitle-text-column" className="d-flex flex-column min-w-0 flex-grow">
        <textarea
          id={`headertitle-textarea-${title}`}
          ref={textAreaRef}
          style={{
            ...styles.renameTextArea,
            ...(!renameTitle && { display: 'none' }),
            width: textAreaWidth,
            height: textAreaHeight,
          }}
          value={title}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
        />
        <div
          id={`headertitle-display-text-${title}`}
          ref={divRef}
          {...(renameTitle && { style: { display: 'none' } })}
          className={`header-title-text min-w-0
        ${isNewTheme ? 'header-title-text-black' : 'header-title-text-white'}`}
          title={title}
        >
          {title}
        </div>
      </div>

      {setTitle && (
        <RMCustomButton
          onClick={renameHandler}
          iconProps={renameIconProps}
          customStyle={styles.renameButtonStyle}
        />
      )}
    </div>
  );
}

const styles: IStyle = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    alignItems: 'center',
    width: '100%',
  },
  renameButtonStyle: {
    marginLeft: 20,
  },
  renameTextArea: {
    display: 'block',
    boxSizing: 'border-box',
    resize: 'none',
    background: 'transparent',
    fontSize: 23,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};
export default HeaderTitle;
